import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sun, Moon, TreePalm, X, Check, Clock, AlertCircle } from 'lucide-react';

const SHIFTS = [
    { id: 1, label: 'Mañana', icon: Sun, color: 'bg-amber-500', shadow: 'shadow-amber-500/20' },
    { id: 2, label: 'Tarde', icon: Moon, color: 'bg-indigo-500', shadow: 'shadow-indigo-500/20' },
    { id: 6, label: 'Libranza', icon: X, color: 'bg-emerald-500', shadow: 'shadow-emerald-500/20' },
    { id: 5, label: 'Vacaciones', icon: TreePalm, color: 'bg-rose-500', shadow: 'shadow-rose-500/20' },
    { id: 23, label: 'Ajuste', icon: Clock, color: 'bg-purple-500', shadow: 'shadow-purple-500/20' },
];

const ManualPainterPalette = ({ isOpen, onClose, onSelect, rangeLabel }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[100] flex items-end justify-center p-4">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                        onClick={onClose}
                    />
                    <motion.div
                        initial={{ y: '100%' }}
                        animate={{ y: 0 }}
                        exit={{ y: '100%' }}
                        className="bg-[var(--bg-secondary)] w-full max-w-md rounded-t-[40px] p-8 pb-12 relative z-10 border-t border-[var(--glass-border)] shadow-2xl"
                    >
                        <div className="w-12 h-1.5 bg-[var(--glass-border)] rounded-full mx-auto mb-6" />
                        
                        <div className="text-center mb-8">
                            <h3 className="text-2xl font-black text-[var(--text-primary)] mb-1">Pintar Calendario</h3>
                            <p className="text-sm text-[var(--text-muted)] font-medium">
                                Selecciona el turno para: <span className="text-cyan-400 font-bold">{rangeLabel}</span>
                            </p>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            {SHIFTS.map((shift) => (
                                <button
                                    key={shift.id}
                                    onClick={() => onSelect(shift.id)}
                                    className={`flex items-center gap-4 p-4 rounded-3xl border border-[var(--glass-border)] bg-[var(--glass-bg)] hover:bg-white/5 transition-all group active:scale-95`}
                                >
                                    <div className={`p-3 rounded-2xl ${shift.color} ${shift.shadow} group-hover:scale-110 transition-transform`}>
                                        <shift.icon className="w-5 h-5 text-white" />
                                    </div>
                                    <span className="font-bold text-[var(--text-primary)] uppercase tracking-widest text-xs">
                                        {shift.label}
                                    </span>
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={onClose}
                            className="w-full mt-6 py-4 rounded-2xl bg-[var(--glass-bg)] border border-[var(--glass-border)] font-black text-[var(--text-muted)] text-xs uppercase tracking-widest hover:text-[var(--text-primary)] transition-colors"
                        >
                            Cancelar
                        </button>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default ManualPainterPalette;
